export class DecodeVinResponse {
  constructor(
    public vin: string = '',
    public make: string[] = [],
    public model: string[] = [],
    public trim: string[] = [],
    public year: string[] = [],
    public inserviceDate: string = '',
    public cartFound: boolean = false,
    public inserviceDateFound: boolean = false,
    public status: boolean = false,
    public message: string = '',
    public manualDecode: boolean = false,
    public loadQuote: boolean = false,
  ) {
  }
}
